<script setup lang="ts">
import { computed } from 'vue'
import { useRoute } from 'vue-router'

import { isTrueish } from '@tix/common-utils/src/Comparisons'

import FlowDetailsPage from '@/pages/FlowDetailsPage.vue'

import LoadingSpinner from '@/components/LoadingSpinner.vue'
import PageLayout from '@/components/templates/PageLayout.vue'

const route = useRoute()
const id = computed(() => route.params.id as string)
const isDetailedMode = computed(() => isTrueish(route.query.detail as string))
const cartId = computed(() => route.query.cartId as string | undefined)
</script>

<template>
  <PageLayout>
    <Suspense>
      <FlowDetailsPage :id="id" :key="id" :cartId="cartId" :isDetailedMode="isDetailedMode" />
      <template #fallback><LoadingSpinner /></template>
    </Suspense>
  </PageLayout>
</template>
